<template>
    <div class="flex items-center justify-center w-full h-full">
        <hts-card>
            <template v-if="loading">
                <p>
                    Đang xác thực lời mời, vui lòng đợi trong giây lát
                </p>
                <progress class="progress w-full" />
            </template>
            <template v-else>
                <p v-if="error">
                    Xác thực không thành công
                </p>
                <p v-else>
                    Xác thực thành công
                </p>
            </template>
        </hts-card>
    </div>
</template>

<script lang="ts" setup>
const { auth, userConfig } = $store()
const route = useRoute()
const store = $store()
const loading = ref(true)
const error = ref(false)

const router = useRouter()

const isDriver = computed(() => {
  return Array.isArray(userConfig?.user?.group?.type) && userConfig.user.group.type.includes('driver')
})
definePageMeta({
  layout: 'auth'
})

onMounted(async () => {
  const token = useRoute().query.token // get token form url
  const accessToken = auth.accessToken

  if (accessToken && token) {
    const api = $url.user.authInviteUser // api get data invite user
    const response = await $api(api, { uriParams: { TOKEN: token } })
    const resData: any = response?.data?.value || {}

    if (resData.success) {
      process.client && $toast().success('Xác thực thành công')

      const workspace = resData.data.workspace
      const companyType = resData.data.companyType
      const cooperatorTypes = resData.data.cooperatorTypes || []
      loading.value = false

      if (!workspace) {
        // To-do: trang chưa có workspace
        return
      }

      store.userConfig.workspaces = [workspace]
      store.userConfig.companyTypes = [companyType]
      const { _sid, companyType: companyTypeW, timezone, type } = workspace
      const workspaceId = _sid
      auth.setWorkspace({ id: _sid, companyType: companyTypeW, timezone, type, cooperatorTypes })

      setTimeout(() => {
        if (cooperatorTypes.includes('PARTNER')) {
          useRouter().push({
            name: 'pp-id',
            params: { id: workspaceId }
          })
        } else if (cooperatorTypes.includes('CUSTOMER')) {
          useRouter().push({
            name: 'pc-id',
            params: { id: workspaceId }
          })
        } else {
          useRouter().push({
            name: 'pp-id',
            params: { id: workspaceId }
          })
        }
      }, 2000)
    } else {
      loading.value = false
      error.value = true
    }
  }
})
</script>
